function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useEffect, useMemo, useState } from "react";
import { insert } from "../cache";
import { subscribe, create, markErrored } from "../entry";
import globalConfig from "../../../config";
// store an empty object to avoid re-rendering when defaults are used
var emptyObject = {};
// Returns a cache entry object that matches the mbox configuration, or creates a new one and returns it
// Also subscribes to the entry to be notified when the entry is updated rerendering the component.
/**
 *
 * @param { config: {name, path, parameters}} configContainer
 * @returns { { payload, state, config } }
 */ export default function useCacheEntry(param) {
    var name = param.name, _param_path = param.path, path = _param_path === void 0 ? null : _param_path, _param_pathRegex = param.pathRegex, pathRegex = _param_pathRegex === void 0 ? null : _param_pathRegex, _param_parameters = param.parameters, parameters = _param_parameters === void 0 ? emptyObject : _param_parameters, _param_profileParameters = param.profileParameters, profileParameters = _param_profileParameters === void 0 ? emptyObject : _param_profileParameters, _param_immediate = param.immediate, immediate = _param_immediate === void 0 ? false : _param_immediate;
    var parametersProperties = useMemo(function() {
        return parameters ? Object.entries(parameters).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            return _to_consumable_array(acc).concat([
                key,
                value
            ]);
        }, []) : [];
    }, [
        parameters
    ]);
    var profileParametersProperties = useMemo(function() {
        return profileParameters ? Object.entries(profileParameters).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            return _to_consumable_array(acc).concat([
                key,
                value
            ]);
        }, []) : [];
    }, [
        profileParameters
    ]);
    // Creating a memoized config that only changes if the attributes change to avoid unnecessary re-renders
    var config = useMemo(function() {
        return {
            name: name,
            path: path,
            pathRegex: pathRegex,
            parameters: parameters,
            profileParameters: profileParameters,
            immediate: immediate
        };
    }, // spreading the parameters object to avoid unnecessary re-renders, no need for static analysis
    [
        name,
        path,
        pathRegex,
        parameters,
        profileParameters
    ].concat(// eslint-disable-next-line react-hooks/exhaustive-deps
    _to_consumable_array(parametersProperties), // eslint-disable-next-line react-hooks/exhaustive-deps
    _to_consumable_array(profileParametersProperties), [
        immediate
    ]));
    // useStates setState acts as reactive publish to trigger component re-renders
    var _useState = _sliced_to_array(useState(function() {
        return insert({
            config: config
        });
    }), 2), cached = _useState[0], setCached = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), unsubscribe = _useState1[0], setUnsubscribe = _useState1[1];
    useEffect(function() {
        // If there is a more specific cache entry, use that instead without triggering a fulfill
        // Also subscribe to the cache entry
        var entry = insert({
            config: _extends({}, config, {
                immediate: false
            })
        });
        // Create a subscription on mount
        // Remove subscription on unmount
        var unsub = subscribe(entry, function(updated) {
            setCached(_extends({}, updated));
        });
        setUnsubscribe(function() {
            return unsub;
        });
        return function() {
            // Remove the subscription
            unsub();
            setUnsubscribe(null);
        };
    }, [
        config
    ]);
    useEffect(function() {
        var _globalConfig_lpeCache, _globalConfig;
        var _globalConfig_lpeCache_defaultTimeoutMS;
        // Set a timeout for the cache entry to be fulfilled
        var ms = (_globalConfig_lpeCache_defaultTimeoutMS = (_globalConfig = globalConfig()) == null ? void 0 : (_globalConfig_lpeCache = _globalConfig.lpeCache) == null ? void 0 : _globalConfig_lpeCache.defaultTimeoutMS) != null ? _globalConfig_lpeCache_defaultTimeoutMS : 3000;
        var timeoutId = setTimeout(function() {
            setCached(function(previousValue) {
                // If the cache entry is not fulfilled, unsubscribe and make this instance fulfill
                if (previousValue.state.done === false) {
                    unsubscribe();
                    // Create an entry that is not connected to the cache
                    // We'll store this in state so we can mark it as errored
                    // Consumers won't know the difference
                    var newEntry = create({
                        config: config
                    });
                    if (newEntry) {
                        markErrored(newEntry, new Error("Observation of cache entry timed out"));
                    }
                    return newEntry;
                }
                return previousValue;
            });
        }, ms);
        return function() {
            clearTimeout(timeoutId);
        };
    }, [
        cached,
        config,
        unsubscribe
    ]);
    // Return the full cache entry
    return cached;
}

//# sourceMappingURL=useCacheEntry.js.map